document.addEventListener('DOMContentLoaded', function () {
  var bars = document.querySelectorAll('.product-sticky-bar[data-watch-target]');

  bars.forEach(function (bar) {
    var targetId = bar.getAttribute('data-watch-target');
    var target = targetId ? document.getElementById(targetId) : null;
    if (!target) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var isPastTarget = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.hidden = !isPastTarget;
        });
      },
      { threshold: 0 }
    );

    observer.observe(target);
  });
});
